import { render } from "./Accessibility.vue?vue&type=template&id=5daf927e&scoped=true"
import script from "./Accessibility.vue?vue&type=script&lang=js"
export * from "./Accessibility.vue?vue&type=script&lang=js"

import "./Accessibility.scss?vue&type=style&index=0&id=5daf927e&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5daf927e"]])

export default __exports__